

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";



import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'

import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
export class CasinoDownload extends React.Component {


    constructor(props) {
        super(props);

        this.createDownloadEvent = this.createDownloadEvent.bind(this);

    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    createDownloadEvent(e) {
        casino.utils.createGoogleTagManagerEvent({
            'event': 'casino_app_download',
            'os': casino.utils.getOperatingSystem()
        });
        // var downloadPokerEventId = 55;
        // casino.repos.eventRepo.create(downloadPokerEventId);
    }
    render() {
        return <div>
            {/* <Header key="header" {...this.state} {...this.props} userHeader="true" headerText="Preuzimanje" headerBackUrl="/"></Header>
                <SecondLevelMenu key="secondLevelMenu" {...this.props}></SecondLevelMenu> */}


            <div id="page-wrapper" className="white padding-nula border-on-tablet margin-1p-on-tablet">


                <div className="casino-download max-width-50">
                    <div className="max-width-50 padding-sides-medium-3">


                        <NavLink to="/">
                            <div className="logo"> </div>
                        </NavLink>

                        <div className="hero1"> </div>
                        <div className="hero2"></div>
                        <div className="hero-height"></div>

                        <h1 className="padding-nula">MOBILNA</h1>

                        <h1>APLIKACIJA</h1>


                        <div className="  margin-bottom margin-top-small ">
                            <a className="btn large fill  as-block" href={casino.config.urls.casinoApk} onClick={this.createDownloadEvent}>
                                <span className="container">
                                    <span className="icon"></span>
                                    <span>PREUZMI SuperCasino</span>
                                    {/*   <span className="badge">BETA</span>*/}
                                </span>
                            </a>
                            <div className="margin-bottom">
                                <span className="text-center as-block text-info">Podržano od Android verzije 5.0</span>
                            </div>
                        </div>
                        <p className="">
                            Preuzmi SuperCasino aplikaciju za Android mobitele! Uživaj u svojoj igri jer se svakodnevno trudimo da ona bude još kvalitetnija i atraktivnija.
                        </p>
                    </div>
                </div>

                <div className="max-width-50 padding-sides-medium-3 text-center margin-top casino-download-prednosti" >

                    <div >
                        <img src="content/images/assets/DownloadCasino/ic_benefit_1.png"></img>
                        <h2>Brzina</h2>
                        <p>Igraj kad i gdje poželiš! Naša je brza aplikacija prilagođena tebi i tvom mobitelu.</p>
                    </div>
                    <div>
                        <img src="content/images/assets/DownloadCasino/ic_benefit_2.png"></img>
                        <h2>Dostupnost</h2>
                        <p>Pružamo ti veliki izbor omiljenih te novih igara na početnom ekranu tvog mobitela.</p>
                    </div>
                    <div>
                        <img src="content/images/assets/DownloadCasino/ic_benefit_3.png"></img>
                        <h2>Optimizacija</h2>
                        <p>Igraj još uzbudljivije jer su igre kvalitetnije i prilagođene dimenzijama tvog mobitela.</p>
                    </div>
                    <div>
                        <img src="content/images/assets/DownloadCasino/ic_benefit_4.png"></img>
                        <h2>Obavijesti</h2>
                        <p>Primaj obavijesti o igrama i novostima iz našeg Casina.</p>
                    </div>


                </div>
                <br></br>
                <div className=" max-width-50">
                    <hr></hr>
                </div>
                <br></br>
                <div className="max-width-50 padding-sides-medium-3  margin-top casino-download-detalji">
                    <h2>Omiljene igre na dohvat ruke</h2>
                    <p>Igraj više od 4.000 omiljenih igara! Zamijeni online mobilni preglednik aplikacijom koja je brža i atraktivnija.</p>
                    <ul>
                        <li>PROMOCIJE, UTRKE I IZAZOVI</li>
                        <li>SVAKI DAN NOVE IGRE</li>
                        <li>JACKPOT IGRE</li>
                        <li>POPULARNE TEME</li>
                        <li>10+ KATEGORIJA</li>
                        {this.props.brands && <li>{Object.keys(this.props.brands).length} PROVIDERA</li>}
                    </ul>
                </div>


                <div className=" max-width-50">
                    <hr></hr>
                </div>



                <div className="max-width-50 padding-sides-medium-3 margin-top">
                    <div className=" margin-bottom ">
                        <br />
                        <span className="text as-block">
                            Ako imaš problema kod preuzimanja aplikacije, slijedi upute.<br /><br />

                            <b>Za verzije Android 8 i novije:</b><br /><br />
                            &nbsp;&nbsp;1. Otvori <b>Postavke.</b><br />
                            &nbsp;&nbsp;2. Pronađi <b>Aplikacije.</b><br />
                            &nbsp;&nbsp;3. Odaberi <b>internetski preglednik</b> koji koristiš.<br />
                            &nbsp;&nbsp;4. Pronađi <b>Instalacija nepoznatih aplikacija.</b><br />
                            &nbsp;&nbsp;5. Omogući opciju <b>Dopusti iz ovog izvora.</b><br />
                            &nbsp;&nbsp;6. Kad omogućiš tu opciju, možeš instalirati aplikaciju.<br /><br />

                            <b>Za verzije starije od Android 8:</b><br /><br />
                            &nbsp;&nbsp;1. Otvori <b>Postavke.</b><br />
                            &nbsp;&nbsp;2. Pronađi <b>Sigurnost.</b><br />
                            &nbsp;&nbsp;3. Omogući <b>Nepoznati izvor.</b><br />
                            &nbsp;&nbsp;4. Kad uključiš tu opciju, možeš instalirati aplikaciju.

                        </span>
                        <br />
                    </div>

                    {/*<div className="poker-download-sigurnost-1"></div>
                        <div className="margin-bottom">
                            <span className="text-center as-block text-info">Izbornik "Postavke" {">"} "Sigurnost"</span>
                        </div>

                        <div className="poker-download-sigurnost-2"></div>
                        <div className="margin-bottom">
                            <span className="text-center as-block text-info">Prihvaćanje uvjeta; Kliknite "U REDU"</span>
                        </div>*/}
                </div>

                <div className="casino-download casino-download2  max-width-50">
                    <div className="max-width-50 padding-sides-medium-3 text-center">
                        <p className="">Samo jedan klik i aplikacija je tvoja.</p>
                        <div className=" margin-bottom-small ">
                            <a className="btn large fill  as-block" href={casino.config.urls.casinoApk} onClick={this.createDownloadEvent}>
                                <span className="container">
                                    <span className="icon"></span>
                                    <span>PREUZMI SuperCasino</span>
                                    {/*     <span className="badge">BETA</span>*/}
                                </span>
                            </a>
                            <div className="margin-bottom">
                                <span className="text-center as-block text-info">Podržano od Android verzije 5.0</span><br></br>
                                <div className="text-center as-block text-info">U slučaju poteškoća sa skidanjem aplikacije preko Google Play-a,  aplikaciju mozete skinuti <a href="https://cdn.supersport.hr/Casino/AndroidApp/Production/supercasino.apk" className="link-btn">ovdje.</a></div>
                            </div>
                        </div>
                    </div>




                </div>
            </div>

            <ObavijestiCasino {...this.props}></ObavijestiCasino>


        </div>

    }
};
